module.exports = __webpack_public_path__ + "img/hzhs2.6320a1d1.jpg";